import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../../../Service/components/Dialog/Dialog';
import { useTheme } from '../../../../theme';
import { ButtonBase } from '@mui/material';
import { ArrowBack } from '../../../../Icons';
import { SafeHtml } from '@shared/ui';

interface Props {
	rules: { html?: string; lang?: string }[];
	open?: boolean;
	onClose: () => void;
}

const FALLBACK_LANG = 'en';

const Rules: React.FC<Props> = ({ rules, open, onClose }) => {
	const { t, i18n } = useTranslation('ServiceAggregation');

	const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;

	const resultRules = React.useMemo(() => {
		if (!rules?.length) {
			return null;
		}

		let filteredRules = rules.filter(rule => rule.lang === i18n?.language);

		if (!filteredRules.length) {
			filteredRules = rules.filter(rule => rule.lang === i18n.options.fallbackLng ?? FALLBACK_LANG);
		}

		return filteredRules.map(rule => rule.html).join('<br/>');
	}, [rules, i18n?.language]);

	const backButton = (onClose: () => void) => {
		return (
			<ButtonBase onClick={onClose} className={theme.close}>
				{ArrowBack}
			</ButtonBase>
		);
	};

	return (
		<Dialog
			isOpen={open}
			onClose={onClose}
			dialogType="fullscreen"
			dialogHeader={t('Terms of use')}
			backButtonRender={backButton}
			content={<SafeHtml tag="div" className={theme.rules__content} html={resultRules} />}
		/>
	);
};

export default Rules;
